export const flows = {
  site_survey: [
    {
      name: "ValidateEquipment",
      path: "/site_survey/validate-equipment",
      maxEquipmentCount: 1,
      minEquipmentCount: 1
    },
    {
      name: "EquipmentValidationComplete",
      path: "/site_survey/equipment-validation-complete"
    },
    /* {
      name: "SiteSurveyFormSelection",
      path: "/site_survey/form-selection"
    }, */
    {
      name: "SiteSurvey",
      path: "/site_survey/data-collection",
      valueLocalizations: "SiteSurveyForm",
      collectedData: "siteSurvey"
    },
    {
      name: "UpdateConfirmation",
      path: "/update/confirmation",
      valueLocalizations: "SiteSurveyForm",
      collectedData: "siteSurvey",
      allowContinueWithoutSaving: false
    }
  ]
};
